// Rapor tutarlılık denetimi — durum / bayatlık / sonuç bandı.
import type { ReportCheckDetail } from "@mahir/shared";
import {
  REPORT_CHECK_COPY,
  reportCheckErrorText,
  reportCheckStatusText,
} from "../../lib/report-check-copy";
import { fillTemplate } from "../../lib/period-ui";

const C = REPORT_CHECK_COPY;

export function ReportCheckBand({ check }: { check: ReportCheckDetail }): JSX.Element {
  const staleCodes = [...check.stale.changed, ...check.stale.added, ...check.stale.removed];
  let line: string;
  if (check.status === "queued" || check.status === "running") {
    line = reportCheckStatusText(check.status);
  } else if (check.status === "failed") {
    line = `${C.status.failed}: ${reportCheckErrorText(check.failureReason)}`;
  } else if (check.resultState === "partial") {
    line = fillTemplate(C.band.resultPartial, {
      n: check.findingCount,
      dropped: check.validation?.droppedUnknownSection ?? 0,
    });
  } else {
    line = fillTemplate(C.band.result, { n: check.findingCount });
  }
  return (
    <div className="mb-3 text-xs" data-testid="report-check-band">
      <p role="status" style={{ color: "var(--color-text-2)" }}>
        {line}
      </p>
      {staleCodes.length > 0 && (
        <p
          className="mt-1 rounded-md p-2"
          data-testid="report-check-stale"
          style={{
            background: "var(--color-warning-bg)",
            border: "1px solid var(--color-warning-border)",
            color: "var(--color-warning-text)",
          }}
        >
          {fillTemplate(C.band.stale, { n: staleCodes.length, codes: staleCodes.join(", ") })}
        </p>
      )}
    </div>
  );
}
